const r = {
  border: "1px solid",
  borderColor: "border-brand",
  backgroundColor: "bg-secondary",
  borderRadius: "radius-1",
  width: "spacing-5",
  height: "spacing-5"
}, o = {
  sm: {
    width: "spacing-4",
    height: "spacing-4"
  },
  md: {
    width: "spacing-5",
    height: "spacing-5"
  }
}, d = { backgroundColor: "bg-brand-primary" }, e = {
  backgroundColor: "bg-disabled",
  borderColor: "border-disabled"
}, s = {
  borderColor: "border-primary",
  backgroundColor: "bg-secondary_hover"
}, b = { borderColor: "bg-primary_hover" }, a = {
  base: r,
  size: o,
  checked: d,
  disabled: e,
  hover: s,
  pressed: b
};
export {
  a as checkbox
};
